import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Input } from "sr/helpers";

type Props = {
  data: { title?: string };
  HandleDataProps: (payload: { title: string }) => void;
  externalErrorId?: string;
};

const RequirementTitleChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [title, setTitle] = useState<string>("");
  const [errorId, setErrorId] = useState<string>("");

  useEffect(() => {
    setTitle(data?.title || "");
  }, [data?.title]);

useImperativeHandle(ref, () => ({
  validateData: () => {
    if (!title?.trim()) {
      setErrorId('INPUT.VALIDATION.REQUIREMENT.TITLE');
      return false;
    }
    setErrorId("");
    return true;
  },
  submitForm: () => {
    const newData = { title: title.trim() };
    HandleDataProps(newData);
    return newData;
  },
}));

  return (
    <div className="space-y-6">
      <Input
        name="title"
        value={title}
        onChange={(e: any) => setTitle(e.target.value)}
        placeholder="Title"
        error={externalErrorId || errorId}
      />
    </div>
  );
});

export default RequirementTitleChange;
